import { createParamDecorator, ExecutionContext } from '@nestjs/common';

export const RawBody = createParamDecorator((data: unknown, context: ExecutionContext) => {
  const { rawBody } = context.switchToHttp().getRequest();
  return rawBody;
});
